<template>
	<form autocomplete="off">
		<div class="container-fluid no-select" ref="stripeCardFormContainer" v-cloak>

			<div class="row row-your-credit" v-if="creditMode">
				<div class="col-12 mt-3">
					<h4 class="text-center"><span class="text-black mb-3">ContentBASE Account Credit: </span><span class="text-black">{{accountCredit}}</span></h4>
				</div>
			</div>

			<div class="row row-your-package" v-if="packageMode">
				<div class="col-12 mt-3">
					<h4 class="text-center"><span class="text-black mb-3">Your Bundle: </span><span class="text-black">{{pckName}}</span></h4>
				</div>
				<div class="col-12 col-no-dp-no-v" v-show="NoDP_NoV">
					<h4><span class="text-black">${{strNrCredits}}</span></h4>
				</div>
				<div class="col-12 col-yes-dp-no-v" v-show="YesDP_NoV">
					<h3><span class="text-gray strike-gray">${{strNrCredits}}</span><span class="text-black ms-3">${{strDiscPerNrCredits}}</span></h3>
					<p><span class="text-green fw-bold">You save ${{strDiscPerSavedNrCredits}} ({{strDiscPerPct}}%)</span></p>
				</div>
				<div class="col-12 col-no-dp-yes-v" v-show="NoDP_YesV">
					<h3><span class="text-gray strike-gray">${{strNrCredits}}</span><span class="text-black ms-3">${{strVoucherNrCredits}}</span></h3>
					<p><span class="text-green fw-bold">You save ${{strVoucherSavedNrCredits}} ({{strVoucherPct}}%)</span></p>
				</div>
			</div>

			<div class="row" v-show="!paymentSuccess">
				<div class="col-12 mt-3">
					<h5 class="text-center text-gray">Creditcard payment details</h5>
				</div>
				<div class="col-12 mt-3">
					<div class="div-card-input overlay-container">
						<input id="stripe-card-holder-name" class="stripe-element stripe-input" type="text" placeholder="Card Holder Name" v-model="stripeObjects.cardHolderName">
						<div class="overlay" v-show="processing"></div>
					</div>
				</div>
				<div class="col-12 mt-3">
					<div class="div-card-input overlay-container">
						<div id="stripe-card-element" class="stripe-element"></div>
						<div class="overlay" v-show="processing"></div>
					</div>
				</div>
				<div class="col-lg-4 order-lg-1 order-3 mt-3 center-all col-loading-indicator" v-show="processing">
					<img src="/img/loaders/Pulse-1s-200px.png" class="img-stripe-loader">
				</div>
				<div class="col-lg-4 order-lg-1 order-3 mt-3 center-all col-promo-code"  v-show="!processing">
					<voucher @code-applied="updateVoucherCode($event)" @code-removed="updateVoucherCode($event)" v-show="showVoucher"></voucher>
				</div>
				<div class="col-lg-4 order-lg-2 order-2 mt-3 center-all col-buy-button">
					<button class="btn btn-primary button-stripe-card-submit" :disabled="processing" @click="clickPurchase">PAY NOW</button>
				</div>
				<div class="col-lg-4 order-lg-3 order-1 mt-3 center-all col-card-icons">
					<img src="/img/credits/4-cards-horizontal.svg" class="img-card-icons">
				</div>

				<div class="col-12 mt-3" v-show="paymentFailure">
					<p class="text-center m-0"><span class="text-danger">{{paymentFailureFeedback}}</span> Please try again.</p>
					<p class="text-center m-0"><a href="/contact/" target="_blank" rel="nofollow">Contact us</a> if you need help.</p>
				</div>
			</div>

			<div class="row mt-3" ref="rowPaymentSuccess" v-show="paymentSuccess">
				<div class="col-12">
					<h5 class="text-center">Payment successfully processed!</h5>
					<p class="big-bold-black text-center">{{enjoyMessage}}</p>
				</div>
			</div>

		</div>
	</form>
</template>




<script>
	// This components depends on:
	// https://js.stripe.com/v3/

	// Test cards:
	// https://stripe.com/docs/testing

	import voucher from '../common/Voucher.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			voucher
		},
		data: () => ({
			stripeObjects : {},
			processing: false,
			paymentFailure: false,
			paymentSuccess: false,
			lastErrorCode: null,
			voucher : {}
		}),
		props: {
			// which mode: credit/package
			mode                : { type: String, default: null },

			// buying account credit mode
			crdNrCredits        : { type: Number, default: 0 },

			// buying package mode
			pckId               : { type: Number, default: 0 },
			pckName             : { type: String, default: null },
			pckNrCredits        : { type: Number, default: 0 },
			pckDiscPerId        : { type: Number, default: null },
			pckDiscPerNrCredits : { type: Number, default: null },

			// other info
			usrNrCredits        : { type: Number, default: 0 }
		},
		mounted() {
			this.initStripe();
		},
		methods: {
			_initStripe(stripeClientInfo) {
				// get stripe public key
				var stripePublicKey = (stripeClientInfo?.data?.publicKey ?? null);
				var stripeKeyNotNull = (stripePublicKey != null);

				// init stripe.js & create ux using stripe elements
				if (stripeKeyNotNull)
				{
					this.stripeObjects.apiPublicKey = stripePublicKey;
					this.stripeObjects.stripe = Stripe(this.stripeObjects.apiPublicKey);
					var elements = this.stripeObjects.stripe.elements();
					this.stripeObjects.cardElement = elements.create('card');
					this.stripeObjects.cardElement.mount('#stripe-card-element');
				}
			},
			initStripe() {
				return this.mixinAxios().get('/api/user/GetStripeApiPublicKey')
					.then((stripeClientInfo) => {
						this._initStripe(stripeClientInfo);
					});
			},
			resetDefaultView() {
				this.paymentFailure = false;
				this.paymentSuccess = false;
			},
			broadcast(nrCredits) {
				Broadcaster.TransmitCreditsRefresh(nrCredits).then(() => {
				});
			},
			showSparkles() {
				var element = this.$refs['rowPaymentSuccess'];

				party.sparkles(element, {
					count: party.variation.range(50, 50),
				});
			},
			setStateToStartProcessing() {
				this.lastErrorCode  = null;
				this.processing     = true;
				this.paymentFailure = false;
				this.paymentSuccess = false;
				this.$emit('payment-started');
			},
			setStateToStopProcessing(success = false) {
				this.processing     = false;
				this.paymentFailure = !success;
				this.paymentSuccess = success;
				this.$emit('payment-stopped');
			},
			_createStripePaymentIntentLog(apiUrl, paymentIntent, paymentCompleted = false) {
				//console.log('_createStripePaymentIntentLog()');

				return this.mixinAxios().post(apiUrl, paymentIntent)
					.then((result) => {
						//console.log('_createStripePaymentIntentLog() - Done()');

						var vals = result.data.vals;
						var data = result.data;

						// payment completed, so handle it
						if (data.success && paymentCompleted) {
							window.NotifyAwin(data.data);
							this.setStateToStopProcessing(true);
							this.broadcast(vals.nrCredits);
							//this.showSparkles();
							this.$emit('payment-completed');
						} else {
							this.setStateToStopProcessing();
						}
					})
					.catch(() => {
						//console.log('_createStripePaymentIntentLog() - Fail()');
						this.setStateToStopProcessing();
					});
			},
			createStripePaymentIntentLog(paymentIntent, paymentCompleted = false) {
				return (this.creditMode)
					? this._createStripePaymentIntentLog('/api/user/CreateStripePaymentIntentLogForCredit', paymentIntent, paymentCompleted)
					: (this.packageMode)
					? this._createStripePaymentIntentLog('/api/user/CreateStripePaymentIntentLogForPackage', paymentIntent, paymentCompleted)
					: null;
			},
			confirmCardPayment() {
				//console.log('confirmCardPayment()');
				return this.stripeObjects.stripe.confirmCardPayment(this.stripeObjects.clientSecret, {
						payment_method: {
							card: this.stripeObjects.cardElement,
							billing_details: {
								name: this.cardHolderName
							}
						}
					})
					.then((result) => {
						//console.log('confirmCardPayment() - Then() - ', result);
						if (result.error) {
							//console.log('confirmCardPayment() Then() - Error');
							console.log(result.error);
							if (result?.error?.payment_intent) {
								this.createStripePaymentIntentLog(result.error.payment_intent);
							}
							this.lastErrorCode = (result?.error?.code ?? null);
							this.setStateToStopProcessing();
						} else if (result.paymentIntent) {
							//console.log('confirmCardPayment() Then() - Success');
							this.createStripePaymentIntentLog(result.paymentIntent, true);
						} else {
							//console.log('confirmCardPayment() Then() - Undefined');
							this.lastErrorCode = 'Undefined';
							this.setStateToStopProcessing();
						}
					});
			},
			createStripePaymentIntentForCredit() {
				//console.log('createStripePaymentIntentForCredit()');

				return this.mixinAxios().post('/api/user/CreateStripePaymentIntentForCredit', this.crdNrCredits, { headers: { 'Content-Type': 'application/json' } })
					.then((result) => {
						//console.log('createStripePaymentIntentForCredit() - Then()');
						var data = result.data;
						this.stripeObjects.clientSecret = data.clientSecret;
						this.confirmCardPayment();
					})
					.catch((error) => {
						//console.log('createStripePaymentIntentForCredit() - Catch()');
						this.setStateToStopProcessing();
					});
			},
			createStripePaymentIntentForPackage() {
				//console.log('createStripePaymentIntentForPackage()');

				var packageIDAndVoucherID = {
					packageID : this.pckId,
					voucherID : this.voucher?.id ?? 0,
					voucherCode : this.voucher?.code ?? ''
				};

				return this.mixinAxios().post('/api/user/CreateStripePaymentIntentForPackage', packageIDAndVoucherID)
					.then((result) => {
						//console.log('createStripePaymentIntentForPackage() - Then()');
						var data = result.data;
						this.stripeObjects.clientSecret = data.clientSecret;
						this.confirmCardPayment();
					})
					.catch((error) => {
						//console.log('createStripePaymentIntentForPackage() - Catch()');
						this.setStateToStopProcessing();
					});
			},
			createStripePaymentIntent() {
				return (this.creditMode)
					? this.createStripePaymentIntentForCredit()
					: (this.packageMode)
					? this.createStripePaymentIntentForPackage()
					: null;
			},
			clickPurchase() {
				this.setStateToStartProcessing();
				this.createStripePaymentIntent();
			},
			updateVoucherCode(voucher) {
				this.voucher = voucher;
			}
		},
		computed: {
			stripeCardFormContainer() {
				return this.$refs['stripeCardFormContainer'];
			},
			cardHolderName() {
				return (this.stripeObjects?.cardHolderName ?? '');
			},
			paymentFailureFeedback() {
				switch (this.lastErrorCode) {
					case 'balance_insufficient'                  : return "Your balance is insufficient.";
					case 'card_decline_rate_limit_exceeded'      : return "Your card has been declined. The rate limit was exceeded.";
					case 'card_declined'                         : return "Your card has been declined.";
					case 'expired_card'                          : return "Your card has expired.";
					case 'expired_card'                          : return "Your card is expired.";
					case 'incomplete_cvc'                        : return "Your card's security code is incomplete.";
					case 'incomplete_number'                     : return "Your card number is incomplete.";
					case 'incomplete_zip'                        : return "Your postal code is incomplete.";
					case 'incorrect_cvc'                         : return "Your card's security code is incorrect.";
					case 'incorrect_number'                      : return "Your card number is incorrect.";
					case 'incorrect_zip'                         : return "Your postal code is incorrect.";
					case 'invalid_card_type'                     : return "Your card type is not supported.";
					case 'invalid_characters'                    : return "You have filled in invalid characters.";
					case 'invalid_cvc'                           : return "Your card's security code is incorrect.";
					case 'invalid_expiry_month'                  : return "Your card's expiration month is incorrect.";
					case 'invalid_expiry_month_past'             : return "Your card's expiration month is in the past.";
					case 'invalid_expiry_year'                   : return "Your card's expiration year is incorrect.";
					case 'invalid_expiry_year_past'              : return "Your card's expiration year is in the past.";
					case 'invalid_number'                        : return "Your card number is incorrect.";
					case 'parameter_invalid_empty'               : return "Your card holder name is not filled in.";
					case 'payment_intent_authentication_failure' : return "We are unable to authenticate your payment method. Please choose a different payment method and try again.";
					default                                      : return 'Something went wrong.';
				}
			},
			voucherApplied() {
				return (this.voucher.id != null);
			},
			voucherNotApplied() {
				return (!this.voucherApplied);
			},
			hasDiscountPeriod() {
				return (this.pckDiscPerId != null);
			},
			notHasDiscountPeriod() {
				return (!this.hasDiscountPeriod);
			},
			showVoucher() {
				var notCreditMode = !this.creditMode;
				return (this.notHasDiscountPeriod && notCreditMode);
			},
			NoDP_NoV() {
				return (this.notHasDiscountPeriod && this.voucherNotApplied);
			},
			YesDP_NoV() {
				return (this.hasDiscountPeriod && this.voucherNotApplied);
			},
			NoDP_YesV() {
				return (this.notHasDiscountPeriod && this.voucherApplied);
			},
			numNrCredits() {
				return this.pckNrCredits;
			},
			numDiscPerPct() {
				return (this.hasDiscountPeriod)
					? (100 - ((this.pckDiscPerNrCredits / this.pckNrCredits) * 100))
					: 0;
			},
			numDiscPerNrCredits() {
				return (this.hasDiscountPeriod)
					? this.pckDiscPerNrCredits
					: 0;
			},
			numDiscPerCreditsSaved() {
				return (this.numNrCredits - this.numDiscPerNrCredits);
			},
			numVoucherPct() {
				return (this.voucherApplied)
					? this.voucher.discountPct
					: 0;
			},
			numVoucherNrCredits() {
				return (this.voucherApplied)
					? (this.pckNrCredits * ((100 - this.voucher.discountPct) / 100))
					: 0;
			},
			numVoucherCreditsSaved() {
				return (this.numNrCredits - this.numVoucherNrCredits);
			},
			strDiscPerPct() {
				return this.numDiscPerPct?.toNrDecimals(0, 2) ?? '';
			},
			strDiscPerNrCredits() {
				return this.numDiscPerNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			strDiscPerSavedNrCredits() {
				return this.numDiscPerCreditsSaved?.toNrDecimals(2, 2) ?? '';
			},
			strVoucherSavedNrCredits() {
				return this.numVoucherCreditsSaved?.toNrDecimals(2, 2) ?? '';
			},
			strVoucherPct() {
				return this.numVoucherPct?.toNrDecimals(0, 2) ?? '';
			},
			strVoucherNrCredits() {
				return this.numVoucherNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			strNrCredits() {
				return this.numNrCredits?.toNrDecimals(2, 2) ?? '';
			},
			modeLower() {
				return this.mode?.toLowerCase();
			},
			creditMode() {
				return (this.modeLower == 'credit');
			},
			packageMode() {
				return (this.modeLower == 'package');
			},
			accountCredit() {
				var strNrCredits = this.crdNrCredits.toNrDecimals(2, 2);
				return `$${strNrCredits}`;
			},
			enjoyMessage() {
				return (this.creditMode)
					? `You have topped up your account credit by ${this.accountCredit}!`
					: (this.packageMode)
					? 'Enjoy your bundle!'
					: null;
			}
		},
		watch: {
		}
	};
</script>




<style scoped>

	/* COMPONENT */

	.stripe-element {
		background-color: #ffffff;
		height: 40px;
		padding: 10px 12px;
		border-radius: 4px;
		border: 1px solid transparent;
		box-shadow: 0 1px 3px 0 #e6ebf1;
		-webkit-transition: box-shadow 150ms ease;
		transition: box-shadow 150ms ease;
	}

	.stripe-input {
		padding: 10px 12px;
		width: 100%;
		outline: none;
		box-sizing: border-box;
	}

	.img-stripe-loader {
		width: 48px;
	}

	.img-card-icons {
		width: 200px;
	}

	.div-card-input {
		margin: auto;
		max-width: 400px;
	}

	.col-loading-indicator {
		height: 62px;
	}

	.col-promo-code {
		height: 62px;
	}

	.col-buy-button {
		height: 62px;
	}

	.col-card-icons {
		height: 62px;
	}

	.col-no-dp-no-v, .col-yes-dp-no-v, .col-no-dp-yes-v {
		text-align: center;
	}

	@media all and (min-width: 992px) {
		.img-card-icons {
			width: 164px;
		}

		.col-loading-indicator {
			justify-content: center !important;
		}

		.col-promo-code {
			justify-content: start !important;
		}

		.col-card-icons {
			justify-content: end !important;
		}
	}

	/* COMPONENT */




	/* BUTTON */

	.button-stripe-card-submit {
		padding: 10px 40px;
		font-size: 1.2rem;
	}

	/* BUTTON */




	/* COMMON */

	[v-cloak] {
		display: none;
	}

	.text-black {
		color: black;
	}

	.text-gray {
		color: gray;
	}

	.text-green {
		color: green;
	}

	.strike-black {
		text-decoration: line-through;
		text-decoration-color: black;
	}

	.strike-gray {
		text-decoration: line-through;
		text-decoration-color: gray;
	}

	.big-bold-black {
		font-size: 1.25rem;
		font-weight: bold;
		color: black;
	}

	.big-bold-green {
		font-size: 17px;
		font-weight: bold;
		color: green;
	}

	.strike {
		text-decoration: line-through;
	}

	.underline {
		text-decoration: underline;
	}

	.center-all {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.overlay-container {
		position: relative;
	}

	.overlay {
		background: black;
		opacity: 0.1;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: 100;
	}

	/* COMMON */

</style>